import React, { Component } from 'react';
import './OrderData.css';
import deadline from '../../../image/deadline.svg';
import replace from '../../../image/replace.svg';
import trash from '../../../image/trash.svg';
import returnx from '../../../image/returnx.svg'
import MapsNewOrder from '../Maps/MapsNewOrder';
import searchbule from '../../../image/searchbule.svg'
import arrow from '../../../image/arrow.svg'
import { QRCode } from "react-qr-svg";
import { Link } from 'react-router-dom';
var moment = require('moment');

class OrderData extends Component {
    render() {
        const handle_state = [['draft', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'delivered', 'failed', 'canceled'],
        ['failed', 'failed', 'failed', 'failed', 'failed', 'failed', 'failed', 'failed', 'ongoing', 'canceled'],
        ['trash', 'trash', 'trash', 'trash', 'trash', 'trash', 'trash', 'trash', 'trash', 'canceled'],
        ['draft', 'return', 'return', 'return', 'return', 'return', 'return', 'return', 'return', 'canceled'],
        ['draft', 'replace', 'replace', 'replace', 'replace', 'replace', 'replace', 'replace', 'replace', 'canceled'],
        ['draft', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'ongoing', 'delivered', 'failed', 'canceled']
        ]
        return (
            <div className="OrderData">
                <div className="row text-center">
                    <div className="col-3 border-right p-2">
                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order ID : </span> {this.props.state.ordernumber}</p>
                    </div>
                    <div className="col-4 border-right p-2">
                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order Price : </span>{this.props.state.totalPrice} </p>

                    </div>
                    <div className="col-5 p-2">
                        <p className="fontsize11  font-weight-bold "><span className="fontsize12">Order date : </span>{(this.props.state.date ? moment(this.props.state.date).format("ll") : '')}</p>
                    </div>
                </div>
                <div className="row p-3">
                    <div className="col-8">

                        <img className="mx-4" src={deadline} alt="deadline" />
                        <span className="fontsize4  font-weight-bold mt-2">{(this.props.state.pickupdate ? moment(this.props.state.pickupdate).format("ll") : '')}</span>
                    </div>

                    <div className="col-4 text-right">
                        <span className={"badge-pill " + handle_state[this.props.state.failedstatus][this.props.state.status]}>{handle_state[this.props.state.failedstatus][this.props.state.status]}</span>
                    </div>

                </div>
                <ul className="timeline">
                    <li className="bg-white  "><div className=" py-3 mx-5 my-2">
                        <p className="fontsize11 bluecolor">Pick up</p>
                        <p className="fontsize11 m-0">{this.props.state.pickupaddress_name}</p>
                    </div></li>
                    <li className="bg-white "><div className=" py-3 mx-5 my-2">
                        <p className="fontsize11 bluecolor">Drop off</p>
                        <p className="fontsize11 m-0">{this.props.state.dropoffaddress_name}</p>
                    </div></li>
                </ul>
                <p className="fontsize11 "> Product quantity: {this.props.state.quantity}  items</p>
                <hr />
                <h3 className=" fontsize9 font-weight-bold">Receiver details</h3>
                <div className="row pt-3">
                    <div className="col-md-4 pt-5">
                        <p className=" fontsize12 text-muted">Reciever</p>
                        <p className="fontsize11 font-weight-bold">{this.props.state.reciver}</p>
                        <p className="fontsize11 mb-0">Collect: <span className="fontsize4  font-weight-bold bluecolor">  {(this.props.state.amount ? this.props.state.amount : '0')}</span></p>

                    </div>
                    <div className="col-md-3 pt-5">
                        <p className=" fontsize12 text-muted">Phone Number</p>
                        <p className="fontsize11 font-weight-bold">{this.props.state.phone}</p>

                    </div>
                    <div className="col-md-3">
                        <QRCode
                            bgColor="#FFFFFF"
                            fgColor="#000000"
                            level="Q"
                            style={{}}
                            value={this.props.state.qrcode}
                        />
                    </div>
                </div>

                {(this.props.state.failedstatus === 1 && this.props.state.status === 4 ?
                    <div className="row">
                        <div className="col-md-3"><Link to={"/Replaceorder/" + this.props.state.ordernumber} className="pointer"><img className="mr-3" src={replace} alt="replace" /><span className="bluecolor">replace</span></Link></div>
                        <div className="col-md-3"><a className="pointer" data-toggle="collapse" href="#returnx" role="button" aria-expanded="false" aria-controls="collapseExample"><img className="mr-3" src={returnx} alt="return" /><span className="bluecolor">return</span></a></div>
                        <div className="col-md-3"><a className="pointer" data-toggle="modal" data-target="#trash"><img className="mr-3" src={trash} alt="trash" /><span className="bluecolor">trash</span></a></div>
                        <div className="modal fade" id="trash" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            {/* Modal  */}
                            <div className="modal-dialog" role="document">
                                <div className="modal-content ">

                                    <div className="modal-body px-lg-5 mt-lg-4 text-center p2">
                                        <p className="fontsize4">Are you sure you want to delete the selected order ? It will be trashed Permantely and you won’t able to restore it</p>
                                    </div>
                                    <div className="modal-footer text-center d-flex justify-content-around  flex-wrap my-3">
                                        <button type="button" onClick={this.props.handetrash} data-dismiss="modal" className="btn my-1 badge-pill  btn-primary">yes</button>
                                        <button type="button" className="btn  badge-pill my-1 border shadow" data-dismiss="modal">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* collapse  */}
                        <div class="collapse mt-2 col-10" id="returnx">
                            <div class="card card-body mx-lg-5  px-lg-5">
                                <MapsNewOrder key={this.props.state.objectaddress_name} setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias} state={this.props.state} />
                                <div className="col-md-12 p-3  px-lg-5">
                                    <div className="form-group relative pb-0 search_div" id="pac-container">
                                        <img className="mr-1 img_input" src={searchbule} alt="search" />
                                        <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="Location" name="address_name" value={this.props.state.address_name} onChange={this.props.handleChange} />
                                        <img className="mr-1 img_input2 pointer" src={arrow} alt="arrow" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />

                                        <div className="dropdown-menu dropdownmapmenu mt-1" aria-labelledby="dropdownMenuButton">

                                            {this.props.state.savedlocations.length > 0 ?
                                                this.props.state.savedlocations.map((x, i) => (
                                                    <a className="dropdown-item pointer" key={i} onClick={this.props.setStateField(x)}>{x.address_name}</a>
                                                )) : <p className="text-center">No Address in (Client Adderss)</p>}
                                        </div>
                                        
                                    </div>
                                    <div style={{ fontSize: 12, color: "red" }} className="text-left">
                                            {this.props.state.address_nameError}
                                        </div>
                                    <div id="map"></div>
                                    <div className="form-group col-12 text-left mt-2">
                                        <label >Adrress Details</label>
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange} />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.props.state.address_aliasError}
                                        </div>
                                    </div>
                             
                                </div>
                                <button onClick={this.props.handleReturnOrderLocation} className="  btn col-md-6 mx-auto text-white badge-pill bluebg">Confirm</button>
                            </div>
                        </div>

                    </div>

                    : '')}


                <hr />
                <p className="fontsize12 text-muted">Delivery Note</p>
                <p className="fontsize11 font-weight-bold">{this.props.state.deliverynote}</p>
            </div>
        )
    }
}
export default OrderData;